import { render, staticRenderFns } from "./TemplateInfo.vue?vue&type=template&id=01f79f39&"
import script from "./TemplateInfo.vue?vue&type=script&lang=js&"
export * from "./TemplateInfo.vue?vue&type=script&lang=js&"
import style0 from "./TemplateInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports